import React, { useState } from 'react';
import '../App.css';
import MainService from '../services/Main.service';
import { useHistory } from 'react-router-dom';
import { AppData } from '../helpers/App.data';

const BoltIcon = () => (
    <svg viewBox="0 0 24 24" fill="white" width="24" height="24">
        <path d="M13 10V3L4 14h7v7l9-11h-7z"/>
    </svg>
);

export default function LoginPage() {
    const mainService = new MainService();
    const appData     = new AppData();
    const history     = useHistory();
    const [loading, setLoading] = useState(false);
    const [error, setError]     = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await mainService.userLogin(e.target);
            if (res.data && res.data.body) {
                appData.setUser({ token: res.data.body.token });
                history.push('/home');
            }
        } catch (err) {
            setError('Invalid credentials. Please try again.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-brand">
                    <div className="login-logo-mark">
                        <BoltIcon />
                    </div>
                    <h1>ServiceOps</h1>
                    <p>Sign in to your dashboard</p>
                </div>

                <form onSubmit={onSubmit} style={{ display: 'block', background: 'none', border: 'none', padding: 0, margin: 0 }}>
                    <div className="login-form-group">
                        <label htmlFor="username">Username or Email</label>
                        <input
                            id="username"
                            type="text"
                            name="username"
                            placeholder="Enter your username"
                            required
                            autoComplete="username"
                        />
                    </div>

                    <div className="login-form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            id="password"
                            type="password"
                            name="password"
                            placeholder="Enter your password"
                            required
                            autoComplete="current-password"
                        />
                    </div>

                    {error && (
                        <div style={{
                            background: 'rgba(239,68,68,0.08)',
                            border: '1px solid rgba(239,68,68,0.2)',
                            color: '#b91c1c',
                            padding: '10px 14px',
                            borderRadius: '8px',
                            fontSize: '0.875rem',
                            marginBottom: '16px',
                        }}>
                            {error}
                        </div>
                    )}

                    <button type="submit" className="login-submit" disabled={loading}>
                        {loading ? <span className="spinner" /> : null}
                        {loading ? 'Signing in…' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
}
